<div [class.pointer-events]="readOnly" [class.review__disabled]="readOnly" class="flex flex-col gap-4">
  <div class="flex review__item">
    <strong class="w-1/3">Private feedback</strong>
    <span class="w-2/3">
      <textarea
        [(ngModel)]="review.private_feedback"
        [disabled]="readOnly"
        [placeholder]="!readOnly ? 'Write your private feedback here' : ''"
        class="review__textarea"></textarea>
    </span>
  </div>
  <div class="flex review__item">
    <strong class="w-1/3">Recommend</strong>
    <span class="w-2/3 flex gap-4">
      <img
        class="clickable"
        [src]="
          review.review.grades.recommend
            ? '/assets/iconography/thumbs-down.svg'
            : '/assets/iconography/thumbs-down-red.svg'
        "
        (click)="review.review.grades.recommend = false" />
      <img
        class="clickable"
        [src]="
          !review.review.grades.recommend
            ? '/assets/iconography/thumbs-up.svg'
            : '/assets/iconography/thumbs-up-green.svg'
        "
        (click)="review.review.grades.recommend = true" />
    </span>
  </div>

  <div class="flex flex-col sm:flex-row review__item">
    <strong class="mb-2 sm:mb-0 sm:w-1/3 mt-2">Cleanliness</strong>
    <div class="sm:w-2/3 flex flex-col gap-2">
      <sbnb-stars
        [startingCount]="review.review.grades.cleanliness"
        (updated)="review.review.grades.cleanliness = $event">
      </sbnb-stars>
      <sbnb-review-tags
        *ngIf="tagsEnabled"
        category="cleanliness"
        [selectedTags]="Array.from(selectedTags.cleanliness)"
        [disabled]="readOnly"
        (tagsChange)="onTagsChange('cleanliness', $event)"
        data-test="cleanliness-tags">
      </sbnb-review-tags>
    </div>
  </div>

  <div class="flex flex-col sm:flex-row review__item">
    <strong class="mb-2 sm:mb-0 sm:w-1/3 mt-2">Communication</strong>
    <div class="sm:w-2/3 flex flex-col gap-2">
      <sbnb-stars
        [startingCount]="review.review.grades.communication"
        (updated)="review.review.grades.communication = $event">
      </sbnb-stars>
      <sbnb-review-tags
        *ngIf="tagsEnabled"
        category="communication"
        [selectedTags]="Array.from(selectedTags.communication)"
        [disabled]="readOnly"
        (tagsChange)="onTagsChange('communication', $event)"
        data-test="communication-tags">
      </sbnb-review-tags>
    </div>
  </div>

  <div class="flex flex-col sm:flex-row review__item">
    <strong class="mb-2 sm:mb-0 sm:w-1/3 mt-2">Respect of house rules</strong>
    <div class="sm:w-2/3 flex flex-col gap-2">
      <sbnb-stars
        [startingCount]="review.review.grades.respect_house_rules"
        (updated)="review.review.grades.respect_house_rules = $event">
      </sbnb-stars>
      <sbnb-review-tags
        *ngIf="tagsEnabled"
        category="respect_house_rules"
        [selectedTags]="Array.from(selectedTags.respect_house_rules)"
        [disabled]="readOnly"
        (tagsChange)="onTagsChange('respect_house_rules', $event)"
        data-test="house-rules-tags">
      </sbnb-review-tags>
    </div>
  </div>

  <div class="bad__review" fxLayout fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutGap="12px">
    <mat-slide-toggle
      [checked]="review.review.bad_review"
      (change)="review.review.bad_review = $event.checked"></mat-slide-toggle>
    <strong>Bad review</strong>
  </div>
  <span *ngIf="!readOnly" class="night-lighter text__small bad__review-helper">
    Delay the publishing of this review to the very last minute of the review period.
  </span>
</div>
